module.exports = __webpack_public_path__ + "img/wash.a9631acb.png";